<template>
  <div class="zj-actionpanel">
    <!-- <i class="el-icon-bell"></i>
    <i class="el-icon-warning-outline"></i> -->
    <el-dropdown class="user-actions" trigger="click" @command="doCmd">
      <span class="el-dropdown-link">
        <el-avatar
          shape="square"
          size="small"
          :src="avatarUrl"
          :title="user.DisplayName"
          style="cursor: pointer"
        ></el-avatar>
        <i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu
        class="zj-actionpanel-dropdown-user-actions"
        slot="dropdown"
      >
        <!-- <el-dropdown-item icon="el-icon-plus" command="passwd"
          >修改密码</el-dropdown-item
        > -->
        <el-dropdown-item icon="el-icon-plus" command="logout"
          >退出</el-dropdown-item
        >
      </el-dropdown-menu>
    </el-dropdown>
    <div class="zj-actionpanel-dialog-password">
      <el-dialog
        title="修改密码"
        :visible.sync="dialogVisible"
        width="35%"
        :before-close="handleClose"
        :append-to-body="true"
        style="text-align: left"
        :destroy-on-close="true"
      >
        <ZjChangePasswd @clickCancel="handleDialogCancel"></ZjChangePasswd>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import ZjChangePasswd from "./ChangePassword.vue";

export default {
  name: "ZjActionPanel",
  props: {
    height: String,
  },
  components: {
    ZjChangePasswd,
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    avatarUrl() {
      const loc = window.location;
      const defaultUrl = loc.protocol + "//" + loc.host + "/img/avatar.png";
      return this.THM("header.avatarUrl", defaultUrl);
    },
  },
  methods: {
    doCmd(action) {
      switch (action) {
        case "passwd":
          this.passwd();
          break;
        case "logout":
          this.logout();
          break;
      }
    },
    //修改密码
    passwd() {
      console.log("点击修改密码");
      this.dialogVisible = true;
    },
    logout() {
      console.log("点击了注销按钮");
      this.logInfo.ActionName = "注销";
      this.logInfo.LogMessage = "注销成功";
      this.logInfo.ModuleName = "登录";
      this.logInfo.PageName = "登出";
      this.addOperationLog();
      if (localStorage.getItem("isIgnoreLogin")=="false") {
        this.user.logout();
        this.$zjapp.emit("logout");
        this.$router.replace({ path: this.BASE_URL });
      } else {
        var userAgent = navigator.userAgent;
        if (
          userAgent.indexOf("Firefox") != -1 ||
          userAgent.indexOf("Chrome") != -1
        ) {
          window.location.href = "about:blank";
          window.close();
        } else {
          window.opener = null;
          window.open("", "_self");
          window.close();
        }
      }
    },
    handleDialogCancel() {
      this.dialogVisible = false;
    },
  },
};
</script>
